import './index_web.css';

import useTheme from '../../../utilities/hooks/theme';
import { View, Text } from '../../../component';
import Button from '@mui/material/Button/Button';
import I18n from '../../../utilities/locale';
import React from 'react';
import { Modal } from '@mui/material';
import constants from '../../../constants';
import { convertToDollars } from '../../../utilities/helper';
import { useSelector } from 'react-redux';

const ContestConfirmModalWeb = ({
  visible,
  onPressDismiss,

  joinContest,

  usableBonusAmount,
  balanceObj,
  totalEntryFee,
  usableBalance
}: any) => {
  const { FantasyTheme: theme } = useTheme();
  let { themeType = 'dark' } = useSelector((state: any) => state.setting);

  // const bottomSheetWidth = isMobileBrowser ? 'root_mobile' : 'root';
  // const className = `${bottomSheetWidth}`;

  const modalContainerColor = {
    background: theme.contestConfirmModalContainer
    // border: `2px solid ${theme.contestConfirmModalBorder}`
  };

  const borderTopColor = {
    borderTopColor: theme.contestConfirmModalBorder
  };

  const simpleTextColor = {
    color: theme.contestConfirmModalTitleText
  };

  const buttonColor: any = {
    background: theme.contestConfirmModalJoinButtonBG,
    color: theme.contestConfirmModalJoinButtonText,
    width: '30%',
    height: '40px',
    fontSize: '1.2rem',
    textTransform: 'none',
    fontFamily: 'ProximaNova-Bold'
  };

  return (
    <Modal open={visible} onClose={onPressDismiss}>
      <View
        style={{ ...modalContainerColor, position: 'fixed', top: '20%' }}
        className={'contest-confirm-modal'}>
        <View
          className={'contest-confirm-modal-row '}
          style={{ ...borderTopColor, justifyContent: 'center' }}>
          <Text className={'contest-confirm-modal-simple-text'} style={simpleTextColor}>
            Confirmation
          </Text>
        </View>
        <View style={{ position: 'absolute', right: '15px', top: '10px' }} onPress={onPressDismiss}>
          <img
            src={themeType === 'dark' ? constants.Images.closeDark : constants.Images.close}
            width="20px"
          />
        </View>
        <View
          className={'confirm-contest-modal-divider'}
          style={{ width: '30%', backgroundColor: '#808594', marginLeft: '35%' }}
        />
        <View className={'contest-confirm-modal-row '} style={borderTopColor}>
          <Text className={'contest-confirm-modal-simple-text'} style={simpleTextColor}>
            {I18n.t('AvailableBalance')}
          </Text>
          <Text
            className={'contest-confirm-modal-simple-text'}
            style={simpleTextColor}>{`${convertToDollars(balanceObj['totalBalance'])}`}</Text>
        </View>
        <View className={'contest-confirm-modal-row '} style={borderTopColor}>
          <Text className={'contest-confirm-modal-simple-text'} style={simpleTextColor}>
            {I18n.t('UsableBonusAmount')}
          </Text>
          <Text
            className={'contest-confirm-modal-simple-text'}
            style={simpleTextColor}>{`${convertToDollars(usableBonusAmount)}`}</Text>
        </View>
        <View className={'contest-confirm-modal-row '} style={borderTopColor}>
          <Text className={'contest-confirm-modal-simple-text'} style={simpleTextColor}>
            {I18n.t('JoiningAmount')}
          </Text>
          <Text
            className={'contest-confirm-modal-simple-text'}
            style={simpleTextColor}>{`${convertToDollars(totalEntryFee)}`}</Text>
        </View>
        <View
          className={'confirm-contest-modal-divider'}
          style={{ width: '90%', backgroundColor: '#808594', marginLeft: '5%' }}
        />
        <Text className={'contest-confirm-modal-footer-text'} style={simpleTextColor}>
          {I18n.t('AcceptAndConfirm')}
        </Text>

        <View className={'contest-confirm-modal-footer'}>
          <Button onClick={() => joinContest(totalEntryFee, usableBalance)} style={buttonColor}>
            {'Join Contest'}
          </Button>
        </View>
      </View>
    </Modal>
  );
};
export default React.memo(ContestConfirmModalWeb);
